import { c as _c } from "react/compiler-runtime";
import type React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { getCurrentAreaInClient } from "@/lib/utils.client";
import { type AddressData, AddressDisplay } from "./address-display";
export interface AddressListData {
  id: string;
  firstName: string;
  lastName: string;
  phone: string;
  address: string;
  addressDetail?: string;
  province: string;
  city: string;
  zipCode: string;
  isDefault?: boolean;
}
export interface AddressListProps {
  addresses: AddressListData[];
  // 选择功能
  selectable?: boolean;
  selectedAddressId?: string;
  onSelectAddress?: (addressId: string) => void;
  onClose?: () => void;
  // 编辑功能
  onEditAddress: (address: AddressListData) => void;
  // 新增功能
  onAddAddress: () => void;
  // 样式变体
  variant?: "drawer" | "module";
  // 空状态
  emptyTitle?: string;
  emptyDescription?: string;
  // 类名
  className?: string;
  itemClassName?: string;
  // Loading 状态
  isLoading?: boolean;
}
const dinProBold = "font-['DINPro-Bold']";
const dinProMedium = "font-['DINPro-Medium']";
const dinProRegular = "font-['DINPro-Regular']";
export const AddressList: React.FC<AddressListProps> = t0 => {
  const $ = _c(68);
  const {
    addresses,
    selectable: t1,
    selectedAddressId,
    onSelectAddress,
    onClose,
    onEditAddress,
    onAddAddress,
    variant: t2,
    emptyTitle,
    emptyDescription,
    className,
    itemClassName,
    isLoading: t3
  } = t0;
  const selectable = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "drawer" : t2;
  const isLoading = t3 === undefined ? false : t3;
  const {
    t,
    i18n
  } = useTranslation();
  i18n.language === "en" ? "en" : "zh";
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const areaCode = getCurrentAreaInClient()?.toUpperCase();
    t4 = (city, province_0, zipCode) => {
      if (areaCode === "TW") {
        return `${province_0} ${city} ${zipCode}`.trim();
      } else {
        return `${city}${city && province_0 ? ", " : ""}${province_0} ${zipCode}`.trim();
      }
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const formatLocation = t4;
  let t5;
  if ($[1] !== onClose || $[2] !== onSelectAddress || $[3] !== selectable) {
    t5 = address => {
      if (selectable && onSelectAddress) {
        onSelectAddress(address.id);
        onClose?.();
      }
    };
    $[1] = onClose;
    $[2] = onSelectAddress;
    $[3] = selectable;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleItemClick = t5;
  let t6;
  if ($[5] !== onClose || $[6] !== onEditAddress || $[7] !== selectable) {
    t6 = (e, address_0) => {
      e.stopPropagation();
      onEditAddress(address_0);
      if (selectable) {
        onClose?.();
      }
    };
    $[5] = onClose;
    $[6] = onEditAddress;
    $[7] = selectable;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleEditClick = t6;
  if (addresses.length === 0 && !isLoading) {
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div className="mb-6 flex h-16 w-16 items-center justify-center text-3xl text-gray-300">📍</div>;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    let t8;
    if ($[10] !== emptyTitle || $[11] !== t) {
      t8 = emptyTitle || t("order.noAddressSaved");
      $[10] = emptyTitle;
      $[11] = t;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    let t9;
    if ($[13] !== t8) {
      t9 = <p className={`${dinProMedium} mb-2 text-lg text-gray-700`}>{t8}</p>;
      $[13] = t8;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    let t10;
    if ($[15] !== emptyDescription || $[16] !== t) {
      t10 = emptyDescription || t("order.addAddressTip");
      $[15] = emptyDescription;
      $[16] = t;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    let t11;
    if ($[18] !== t10) {
      t11 = <p className={`mb-8 text-sm text-gray-500 ${dinProRegular}`}>{t10}</p>;
      $[18] = t10;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    let t12;
    if ($[20] !== t) {
      t12 = t("order.addNewAddressBtn");
      $[20] = t;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    let t13;
    if ($[22] !== isLoading || $[23] !== onAddAddress || $[24] !== t12) {
      t13 = <Button className={`w-full max-w-xs bg-black py-3 text-white ${dinProMedium} hover:bg-gray-800`} onClick={onAddAddress} loading={isLoading}>{t12}</Button>;
      $[22] = isLoading;
      $[23] = onAddAddress;
      $[24] = t12;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    let t14;
    if ($[26] !== t11 || $[27] !== t13 || $[28] !== t9) {
      t14 = <div className="flex h-full w-full flex-col items-center justify-center p-6 text-center md:p-10">{t7}{t9}{t11}{t13}</div>;
      $[26] = t11;
      $[27] = t13;
      $[28] = t9;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    return t14;
  }
  if (isLoading && addresses.length === 0) {
    let t7;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div className="mb-6 flex h-16 w-16 items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-black" /></div>;
      $[30] = t7;
    } else {
      t7 = $[30];
    }
    let t8;
    if ($[31] !== t) {
      t8 = t("common.loading");
      $[31] = t;
      $[32] = t8;
    } else {
      t8 = $[32];
    }
    let t9;
    if ($[33] !== t8) {
      t9 = <div className="flex h-full w-full flex-col items-center justify-center p-6 text-center md:p-10">{t7}<p className={`${dinProMedium} text-lg text-gray-700`}>{t8}</p></div>;
      $[33] = t8;
      $[34] = t9;
    } else {
      t9 = $[34];
    }
    return t9;
  }
  let t7;
  if ($[35] !== addresses || $[36] !== handleEditClick || $[37] !== handleItemClick || $[38] !== itemClassName || $[39] !== selectable || $[40] !== selectedAddressId || $[41] !== t || $[42] !== variant) {
    let t8;
    if ($[44] !== handleEditClick || $[45] !== handleItemClick || $[46] !== itemClassName || $[47] !== selectable || $[48] !== selectedAddressId || $[49] !== t || $[50] !== variant) {
      t8 = address_1 => {
        const addressData = {
          firstName: address_1.firstName,
          lastName: address_1.lastName,
          phone: address_1.phone,
          address: address_1.address,
          addressDetail: address_1.addressDetail,
          province: address_1.province,
          city: address_1.city,
          zipCode: address_1.zipCode
        };
        if (variant === "drawer") {
          return <div key={address_1.id} className={`relative w-full rounded-lg border-2 bg-white p-4 transition-all ${selectable ? `cursor-pointer ${selectedAddressId === address_1.id ? "border-black" : "border-gray-200 hover:border-gray-300"}` : "border-gray-200"} ${itemClassName || ""}`} onClick={() => handleItemClick(address_1)}>{address_1.isDefault && <span className={`absolute top-4 right-4 rounded  text-[#7B5E25] bg-[#FFF3D6] px-2 py-1 text-xs  ${dinProMedium}`}>{t("order.default")}</span>}<Button variant="link" className={`absolute right-4 bottom-4 h-auto p-0 text-xs text-gray-500 hover:text-gray-700 ${dinProRegular}`} onClick={e_0 => handleEditClick(e_0, address_1)}>{t("common.edit")}</Button><div className="w-full"><div className="mb-2"><p className={`${dinProBold} text-base text-gray-900`}>{address_1.lastName} {address_1.firstName}</p></div><AddressDisplay data={addressData} variant="card" showFullName={false} province={address_1.province} formatLocation={formatLocation} /></div></div>;
        }
        return <div key={address_1.id} className={`flex items-stretch justify-between border border-black bg-[#f5f5f5] p-3 md:bg-white md:p-6 md:hover:bg-[#f5f5f5] ${selectable ? "cursor-pointer" : ""} ${itemClassName || ""}`} onClick={() => selectable && handleItemClick(address_1)}><div className="min-w-0 flex-1"><AddressDisplay data={addressData} variant="default" province={address_1.province} formatLocation={formatLocation} /></div><div className={"ml-2 shrink\t flex-col items-end justify-between gap-2"}>{address_1.isDefault ? <span className="flex items-center justify-center bg-[#ffedc2] p-[0.1875rem_0.25rem] font-['DINPro-Regular'] text-[0.75rem] font-normal whitespace-nowrap text-[#7b5e25]">{t("address.default")}</span> : <div />}<div><Button variant="link" className="p-0! text-sm" onClick={e_1 => handleEditClick(e_1, address_1)}>{t("common.edit")}</Button></div></div></div>;
      };
      $[44] = handleEditClick;
      $[45] = handleItemClick;
      $[46] = itemClassName;
      $[47] = selectable;
      $[48] = selectedAddressId;
      $[49] = t;
      $[50] = variant;
      $[51] = t8;
    } else {
      t8 = $[51];
    }
    t7 = addresses.map(t8);
    $[35] = addresses;
    $[36] = handleEditClick;
    $[37] = handleItemClick;
    $[38] = itemClassName;
    $[39] = selectable;
    $[40] = selectedAddressId;
    $[41] = t;
    $[42] = variant;
    $[43] = t7;
  } else {
    t7 = $[43];
  }
  const t8 = variant === "drawer" ? "default" : "outline";
  const t9 = variant === "drawer" ? "default" : "lg";
  const t10 = `w-full ${variant === "drawer" ? `bg-black py-3 text-white ${dinProMedium} rounded-lg hover:bg-gray-800` : `mt-8 border-black! font-bold uppercase ${addresses.length > 0 ? "md:hidden" : ""}`}`;
  let t11;
  if ($[52] !== t || $[53] !== variant) {
    t11 = variant === "drawer" ? t("order.addNewAddress") : t("account.addresses.addNewAddress");
    $[52] = t;
    $[53] = variant;
    $[54] = t11;
  } else {
    t11 = $[54];
  }
  let t12;
  if ($[55] !== isLoading || $[56] !== onAddAddress || $[57] !== t10 || $[58] !== t11 || $[59] !== t8 || $[60] !== t9) {
    t12 = <Button variant={t8} size={t9} className={t10} onClick={onAddAddress} loading={isLoading}>{t11}</Button>;
    $[55] = isLoading;
    $[56] = onAddAddress;
    $[57] = t10;
    $[58] = t11;
    $[59] = t8;
    $[60] = t9;
    $[61] = t12;
  } else {
    t12 = $[61];
  }
  let t13;
  if ($[62] !== t12 || $[63] !== t7) {
    t13 = <div className="w-full space-y-3">{t7}{t12}</div>;
    $[62] = t12;
    $[63] = t7;
    $[64] = t13;
  } else {
    t13 = $[64];
  }
  let t14;
  if ($[65] !== className || $[66] !== t13) {
    t14 = <div className={className}>{t13}</div>;
    $[65] = className;
    $[66] = t13;
    $[67] = t14;
  } else {
    t14 = $[67];
  }
  return t14;
};